<div>
  <h1>Выбор устройства для стриминга видео</h1>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Выбор видеоустройства</mat-label>
      <mat-select (selectionChange)="onVideoSourceChange($event)">
        <mat-option *ngFor="let device of videoDevices" [value]="device.deviceId">
          {{ device.label || 'Камера ' + device.deviceId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Выбор аудиоустройства</mat-label>
      <mat-select (selectionChange)="onAudioSourceChange($event)">
        <mat-option *ngFor="let device of audioDevices" [value]="device.deviceId">
          {{ device.label || 'Микрофон ' + device.deviceId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <button mat-raised-button color="primary" (click)="startStream()">Начать стрим</button>
  <video #videoElement width="640" height="480" autoplay></video>
</div>